export const currencies = [
    {
        decimalScale: 2,
        symbol: 'دإ',
        text: 'Utd. Arab Emir. Dirham',
        value: 'aed',
    },
    {
        decimalScale: 2,
        symbol: '؋',
        text: 'Afghanistan Afghani',
        value: 'afn',
    },
    {
        decimalScale: 2,
        symbol: 'L',
        text: 'Albanian Lek',
        value: 'all',
    },
    {
        decimalScale: 2,
        symbol: '֏',
        text: 'Armenian Dram',
        value: 'amd',
    },
    {
        decimalScale: 2,
        symbol: 'ƒ',
        text: 'NL Antillian Guilder',
        value: 'ang',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Angolan Kwanza',
        value: 'aoa',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Argentine Peso',
        value: 'ars',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Australian Dollar',
        value: 'aud',
    },
    {
        decimalScale: 2,
        symbol: 'ƒ',
        text: 'Aruban Florin',
        value: 'awg',
    },
    {
        decimalScale: 2,
        symbol: '₼',
        text: 'Azerbaijan New Manat',
        value: 'azn',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Bosnian Mark',
        value: 'bam',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Barbados Dollar',
        value: 'bbd',
    },
    {
        decimalScale: 2,
        symbol: '৳',
        text: 'Bangladeshi Taka',
        value: 'bdt',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Bulgarian Lev',
        value: 'bgn',
    },
    {
        decimalScale: 3,
        symbol: '',
        text: 'Bahraini Dinar',
        value: 'bhd',
    },
    {
        decimalScale: 0,
        symbol: '',
        text: 'Burundi Franc',
        value: 'bif',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Bermudian Dollar',
        value: 'bmd',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Brunei Dollar',
        value: 'bnd',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Bolivian Boliviano',
        value: 'bob',
    },
    {
        decimalScale: 2,
        symbol: 'R$',
        text: 'Brazilian Real',
        value: 'brl',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Bahamian Dollar',
        value: 'bsd',
    },
    /* This currency is not working on the API
    {
      text: 'Bitcoin',
      value: 'btc',
      decimalScale: 2,
    },
    */
    {
        decimalScale: 2,
        symbol: '',
        text: 'Bhutan Ngultrum',
        value: 'btn',
    },
    {
        decimalScale: 2,
        symbol: 'P',
        text: 'Botswana Pula',
        value: 'bwp',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Belarusian ruble',
        value: 'byn',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Belize Dollar',
        value: 'bzd',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Canadian Dollar',
        value: 'cad',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Congolese Franc',
        value: 'cdf',
    },
    {
        decimalScale: 2,
        symbol: '₣',
        text: 'Swiss Franc',
        value: 'chf',
    },
    {
        decimalScale: 4,
        symbol: '',
        text: 'Chilean Unidad de Fomento',
        value: 'clf',
    },
    {
        decimalScale: 0,
        symbol: '$',
        text: 'Chilean Peso',
        value: 'clp',
    },
    {
        decimalScale: 2,
        symbol: '¥',
        text: 'Chinese Yuan Renminbi',
        value: 'cny',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Colombian Peso',
        value: 'cop',
    },
    {
        decimalScale: 2,
        symbol: '₡',
        text: 'Costa Rican Colon',
        value: 'crc',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Cuban Convertible Peso',
        value: 'cuc',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Cuban Peso',
        value: 'cup',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Cape Verde Escudo',
        value: 'cve',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Czech Koruna',
        value: 'czk',
    },
    {
        decimalScale: 0,
        symbol: '',
        text: 'Djibouti Franc',
        value: 'djf',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Danish Krone',
        value: 'dkk',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Dominican R. Peso',
        value: 'dop',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Algerian Dinar',
        value: 'dzd',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Egyptian Pound',
        value: 'egp',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Eritrean Nakfa',
        value: 'ern',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Ethiopian Birr',
        value: 'etb',
    },
    {
        decimalScale: 2,
        symbol: '€',
        text: 'Euro',
        value: 'eur',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Fiji Dollar',
        value: 'fjd',
    },
    {
        decimalScale: 2,
        symbol: '£',
        text: 'Falkland Islands Pound',
        value: 'fkp',
    },
    {
        decimalScale: 2,
        symbol: '£',
        text: 'British Pound',
        value: 'gbp',
    },
    {
        decimalScale: 2,
        symbol: '₾',
        text: 'Georgian Lari',
        value: 'gel',
    },
    /* This currency is not working on the API
    {
      text: 'Guernsey Pound',
      value: 'ggp',
      decimalScale: 2,
    },
    */
    {
        decimalScale: 2,
        symbol: '₵',
        text: 'Ghanaian New Cedi',
        value: 'ghs',
    },
    {
        decimalScale: 2,
        symbol: '£',
        text: 'Gibraltar Pound',
        value: 'gip',
    },
    {
        decimalScale: 2,
        symbol: 'D',
        text: 'Gambian Dalasi',
        value: 'gmd',
    },
    {
        decimalScale: 0,
        symbol: '',
        text: 'Guinea Franc',
        value: 'gnf',
    },
    {
        decimalScale: 2,
        symbol: 'Q',
        text: 'Guatemalan Quetzal',
        value: 'gtq',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Guyanese Dollar',
        value: 'gyd',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Hong Kong Dollar',
        value: 'hkd',
    },
    {
        decimalScale: 2,
        symbol: 'L',
        text: 'Honduran Lempira',
        value: 'hnl',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Croatian Kuna',
        value: 'hrk',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Haitian Gourde',
        value: 'htg',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Hungarian Forint',
        value: 'huf',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Indonesian Rupiah',
        value: 'idr',
    },
    {
        decimalScale: 2,
        symbol: '₪',
        text: 'Israeli New Shekel',
        value: 'ils',
    },
    /* This currency is not working on the API
    {
      text: 'Isle of Man Pound',
      value: 'imp',
      decimalScale: 2,
    },
    */
    {
        decimalScale: 2,
        symbol: '₹',
        text: 'Indian Rupee',
        value: 'inr',
    },
    {
        decimalScale: 3,
        symbol: '',
        text: 'Iraqi Dinar',
        value: 'iqd',
    },
    {
        decimalScale: 2,
        symbol: '﷼',
        text: 'Iranian Rial',
        value: 'irr',
    },
    {
        decimalScale: 0,
        symbol: '',
        text: 'Iceland Krona',
        value: 'isk',
    },
    /* This currency is not working on the API
    {
      text: 'Jersey Pound',
      value: 'jep',
      decimalScale: 2,
    },
    */
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Jamaican Dollar',
        value: 'jmd',
    },
    {
        decimalScale: 3,
        symbol: '',
        text: 'Jordanian Dinar',
        value: 'jod',
    },
    {
        decimalScale: 0,
        symbol: '¥',
        text: 'Japanese Yen',
        value: 'jpy',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Kenyan Shilling',
        value: 'kes',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Kyrgyzstanian Som',
        value: 'kgs',
    },
    {
        decimalScale: 2,
        symbol: '៛',
        text: 'Cambodian Riel',
        value: 'khr',
    },
    {
        decimalScale: 0,
        symbol: '',
        text: 'Comoros Franc',
        value: 'kmf',
    },
    {
        decimalScale: 2,
        symbol: '₩',
        text: 'North Korean Won',
        value: 'kpw',
    },
    {
        decimalScale: 0,
        symbol: '₩',
        text: 'South Korean Won',
        value: 'krw',
    },
    {
        decimalScale: 3,
        symbol: '',
        text: 'Kuwaiti Dinar',
        value: 'kwd',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Cayman Islands Dollar',
        value: 'kyd',
    },
    {
        decimalScale: 2,
        symbol: '₸',
        text: 'Kazakhstan Tenge',
        value: 'kzt',
    },
    {
        decimalScale: 2,
        symbol: '₭',
        text: 'Lao Kip',
        value: 'lak',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Lebanese Pound',
        value: 'lbp',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Sri Lanka Rupee',
        value: 'lkr',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Liberian Dollar',
        value: 'lrd',
    },
    {
        decimalScale: 2,
        symbol: 'L',
        text: 'Lesotho Loti',
        value: 'lsl',
    },
    {
        decimalScale: 3,
        symbol: '',
        text: 'Libyan Dinar',
        value: 'lyd',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Moroccan Dirham',
        value: 'mad',
    },
    {
        decimalScale: 2,
        symbol: 'L',
        text: 'Moldovan Leu',
        value: 'mdl',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Malagasy Ariary',
        value: 'mga',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Macedonian Denar',
        value: 'mkd',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Myanmar Kyat',
        value: 'mmk',
    },
    {
        decimalScale: 2,
        symbol: '₮',
        text: 'Mongolian Tugrik',
        value: 'mnt',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Macau Pataca',
        value: 'mop',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Mauritanian ouguiya',
        value: 'mru',
    },
    {
        decimalScale: 2,
        symbol: '₨',
        text: 'Mauritius Rupee',
        value: 'mur',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Maldive Rufiyaa',
        value: 'mvr',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Malawi Kwacha',
        value: 'mwk',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Mexican Peso',
        value: 'mxn',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Malaysian Ringgit',
        value: 'myr',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Mozambique New Metical',
        value: 'mzn',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Namibia Dollar',
        value: 'nad',
    },
    {
        decimalScale: 2,
        symbol: '₦',
        text: 'Nigerian Naira',
        value: 'ngn',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Nicaraguan Cordoba Oro',
        value: 'nio',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Norwegian Kroner',
        value: 'nok',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Nepalese Rupee',
        value: 'npr',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'New Zealand Dollar',
        value: 'nzd',
    },
    {
        decimalScale: 3,
        symbol: '',
        text: 'Omani Rial',
        value: 'omr',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Panamanian Balboa',
        value: 'pab',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Peruvian Nuevo Sol',
        value: 'pen',
    },
    {
        decimalScale: 2,
        symbol: 'K',
        text: 'Papua New Guinea Kina',
        value: 'pgk',
    },
    {
        decimalScale: 2,
        symbol: '₱',
        text: 'Philippine Peso',
        value: 'php',
    },
    {
        decimalScale: 2,
        symbol: '₨',
        text: 'Pakistan Rupee',
        value: 'pkr',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Polish Zloty',
        value: 'pln',
    },
    {
        decimalScale: 0,
        symbol: '₲',
        text: 'Paraguay Guarani',
        value: 'pyg',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Qatari Rial',
        value: 'qar',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Romanian New Lei',
        value: 'ron',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Serbian Dinar',
        value: 'rsd',
    },
    {
        decimalScale: 2,
        symbol: '₽',
        text: 'Russian Rouble',
        value: 'rub',
    },
    {
        decimalScale: 0,
        symbol: '',
        text: 'Rwandan Franc',
        value: 'rwf',
    },
    {
        decimalScale: 2,
        symbol: '﷼',
        text: 'Saudi Riyal',
        value: 'sar',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Solomon Islands Dollar',
        value: 'sbd',
    },
    {
        decimalScale: 2,
        symbol: '₨',
        text: 'Seychelles Rupee',
        value: 'scr',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Sudanese Pound',
        value: 'sdg',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Swedish Krona',
        value: 'sek',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Singapore Dollar',
        value: 'sgd',
    },
    {
        decimalScale: 2,
        symbol: '£',
        text: 'St. Helena Pound',
        value: 'shp',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Sierra Leone Leone',
        value: 'sll',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Somali Shilling',
        value: 'sos',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Suriname Dollar',
        value: 'srd',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'São Tomé and Príncipe dobra',
        value: 'stn',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'El Salvador Colon',
        value: 'svc',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Syrian Pound',
        value: 'syp',
    },
    {
        decimalScale: 2,
        symbol: 'L',
        text: 'Swaziland Lilangeni',
        value: 'szl',
    },
    {
        decimalScale: 2,
        symbol: '฿',
        text: 'Thai Baht',
        value: 'thb',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Tajikistani Somoni',
        value: 'tjs',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Turkmenistan New Manat',
        value: 'tmt',
    },
    {
        decimalScale: 3,
        symbol: '',
        text: 'Tunisian Dinar',
        value: 'tnd',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Tonga Pa’anga',
        value: 'top',
    },
    {
        decimalScale: 2,
        symbol: '₺',
        text: 'Turkish New Lira',
        value: 'try',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Trinidad/Tobago Dollar',
        value: 'ttd',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Taiwan Dollar',
        value: 'twd',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Tanzanian Shilling',
        value: 'tzs',
    },
    {
        decimalScale: 2,
        symbol: '₴',
        text: 'Ukraine Hryvnia',
        value: 'uah',
    },
    {
        decimalScale: 0,
        symbol: '',
        text: 'Uganda Shilling',
        value: 'ugx',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'US Dollar',
        value: 'usd',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Uruguayan Peso',
        value: 'uyu',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Uzbekistani Som',
        value: 'uzs',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Venezuelan bolívar soberano',
        value: 'ves',
    },
    {
        decimalScale: 0,
        symbol: '₫',
        text: 'Vietnamese Dong',
        value: 'vnd',
    },
    {
        decimalScale: 0,
        symbol: '',
        text: 'Vanuatu Vatu',
        value: 'vuv',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Samoan Tala',
        value: 'wst',
    },
    {
        decimalScale: 0,
        symbol: '',
        text: 'CFA Franc BEAC',
        value: 'xaf',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'East Caribbean Dollar',
        value: 'xcd',
    },
    {
        decimalScale: 0,
        symbol: '',
        text: 'CFA Franc BCEAO',
        value: 'xof',
    },
    {
        decimalScale: 0,
        symbol: '',
        text: 'CFP Franc',
        value: 'xpf',
    },
    {
        decimalScale: 2,
        symbol: '﷼',
        text: 'Yemeni Rial',
        value: 'yer',
    },
    {
        decimalScale: 2,
        symbol: 'R',
        text: 'South African Rand',
        value: 'zar',
    },
    {
        decimalScale: 2,
        symbol: '',
        text: 'Zambian Kwacha',
        value: 'zmw',
    },
    {
        decimalScale: 2,
        symbol: '$',
        text: 'Zimbabwean dollar',
        value: 'zwl',
    },
];
